<template>
  <div class="advertistin_pages">
    <div class="tencent">
      <div class="row1">覆盖淮南3家医院，200+专家医生</div>
      <div class="code hp_center">
        <img src="@/assets/advertising/code.jpg" alt />
      </div>
      <div class="row2">
        <div>关注淮南智慧医疗公众号</div>
        <div>挂号无需等待 排号实时提醒</div>
      </div>
    </div>
    <div class="specialists">
      <div class="recommend hp_cz_center_s">
        <span>推荐专家</span>
        <span
          class="cursor-point"
          @click="changeDoctor"
          style="color:#40a9ff;font-size:15px;margin-right:25px;"
          >换一换</span
        >
      </div>
      <div
        v-for="(item, index) in sortLists"
        :key="index"
        class="specialist_demo hp_flex"
      >
        <div class="hospitalImg hp_center">
          <img v-if="item.avatar" :src="base_url + item.avatar" alt />
          <img v-else src="@/assets/default-img/doctor.png" alt />
        </div>
        <div class="doctor hp_space_between">
          <div>
            <div>
              <span class="name" style="margin-right:8px;">
                {{ item.name }}
              </span>
              <span class="job">{{ item.title }}</span>
            </div>
            <div class="hospital">{{ item.hospitalName }}</div>
          </div>
          <a-button
            style="border-radius: 10px;font-size:12px;width:77px;height:24px;"
            @click="goNext(item)"
            type="primary"
            >立即挂号</a-button
          >
        </div>
      </div>
    </div>
    <div>
      <div class="demo hp_center cursor-point">
        <img
          v-for="(item, index) in adverts2"
          :key="index"
          :src="base_url + item.images"
          alt
          @click="goUrlLink(item.sourceUrl)"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { getSort } from '@/api/advertising'
import { getAdverts } from '@/api/index'
export default {
  data() {
    return {
      form: {
        pageNum: 1,
        pageSize: 3,
      },
      sortLists: [],
      totalPage: 0,
      advertForm: {
        pageNum: 1,
        pageSize: 1,
      },
      adverts2: [], //右边广告
    }
  },
  created() {
    this.getData()
    this.initAdverts2()
  },
  methods: {
    //获取热门医生
    async getData() {
      let res = await getSort(this.form)
      this.sortLists = res.data.list || []
      this.totalPage = res.data.totalPage
    },
    //获取右边广告
    async initAdverts2() {
      let res = await getAdverts({ ...this.advertForm, position: 2 })
      if (res.code == 200) {
        this.adverts2 = res.data.list
        return
      }
      this.adverts2 = []
    },
    //换一换按钮
    changeDoctor() {
      this.form.pageNum++
      if (this.form.pageNum > this.totalPage) {
        this.form.pageNum = 1
      }
      this.getData()
    },
    //前往医生详情
    goNext(item) {
      this.$router.push('/registered/doctor/' + item.id + '/' + 0)
    },
    goUrlLink(url) {
      window.location.href = url
    },
  },
}
</script>
<style scoped lang="less">
.advertistin_pages {
  margin-left: 30px;
  .tencent {
    width: 261px;
    background: #4694ff;
    margin: 0 auto;
    border-radius: 10px;
    padding-top: 20px;
    padding-bottom: 16px;
    margin-bottom: 30px;
    .row1 {
      text-align: center;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
    }
    .code {
      margin: 0 auto;
      width: 149px;
      height: 154px;
      background-image: url('../assets/advertising/advertising.png');
      background-size: cover;
      background-repeat: no-repeat;
      img {
        width: 120px;
        height: 120px;
      }
    }
    .row2 {
      margin-top: 8px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #ffffff;
      div {
        text-align: center;
      }
    }
  }
  .specialists {
    box-shadow: 0px 0px 21px 0px rgba(154, 200, 255, 0.32);
    padding-top: 10px;
    padding-left: 20px;
    padding-bottom: 20px;
    border-radius: 10px;
    .recommend {
      height: 60px;
      span {
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }
    }
    .specialist_demo {
      .hospitalImg {
        width: 86px;
        height: 90px;
        margin-right: 9px;
        overflow: hidden;
        img {
          height: 90px;
        }
      }
      .doctor {
        flex: 1;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        flex-direction: column;
        padding-right: 10px;
        .hospital {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
    .specialist_demo:nth-child(3) {
      margin: 20px 0;
    }
  }
  .demo {
    margin-top: 20px;
    width: 262px;
    height: 240px;
    overflow: hidden;
    border-radius: 10px;
    img {
      height: 100%;
    }
  }
}
</style>
